import { InjectionToken } from '@angular/core';

import { ChatLibConfig } from '@lib/chat/models/chat-config.interface';

export const CHAT_LIB_CONFIG = new InjectionToken<ChatLibConfig>('CHAT_LIB_CONFIG');
export const CHAT_API_URL = new InjectionToken<string>('CHAT_API_URL');
